import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ShowsPage from "./pages/ShowsPage";
import SubmitStoryPage from "./pages/SubmitStoryPage";
import PodcastPage from "./pages/PodcastPage";
import AboutPage from "./pages/AboutPage";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/shows" element={<ShowsPage />} />
            <Route path="/submit" element={<SubmitStoryPage />} />
            <Route path="/podcast" element={<PodcastPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
